export enum NotesToInclude {
    BASIC = 0,
    VERIFICATION = 1,
    BOTH = 2
}